
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/register",
      function () {
        return require("private-next-pages/events/register/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/register"])
      });
    }
  